import { useContext } from 'react';
import { Context } from '../../../Context';
import styles from '../../../styles/aprt.module.scss';
import buttons_styles from '../../../styles/buttons.module.scss';


function ApartmentQueryButton({ 
	isStuck = false, 
	isBackendWeblo = false 
}) {
	const { activeApartmentData } = useContext(Context);

	const handleClickExternally = () => {
		const eventDetail = {
			number: activeApartmentData.id_original,
		};

		const customEvent = new CustomEvent('cadaplusApartmentQueryClick', {
			detail: eventDetail,
			bubbles: true,
			composed: true,
		});
		document.dispatchEvent(customEvent);

		const url = new URL(window.location.href);
		url.searchParams.set('id_investment', activeApartmentData.project_crm_id);
		url.searchParams.set('id_product', activeApartmentData.unit_crm_id);
		url.hash = 'kontakt';

		window.history.pushState({}, '', url.toString());

		const contactElement = document.getElementById('kontakt');
		if (contactElement) {
			contactElement.scrollIntoView({ behavior: 'smooth' });
		}
	};

	const handleClickInternally = () => {
		const messageField = document.querySelector('#form-field-message');
		if (messageField) {
			messageField.value = `Witam, zainteresowała mnie oferta lokalu ${activeApartmentData.id_original}. Proszę o więcej informacji.`;

			const contactElement = document.querySelector('#kontakt');
			if (contactElement) {
				contactElement.scrollIntoView({ behavior: 'smooth' });
			}
		} else {
			console.warn(
				'Message field not found, falling back to external handling, emitting event'
			);
			handleClickExternally();
		}
	};

	const handleClick = isBackendWeblo
		? handleClickInternally
		: handleClickExternally;

	if (!activeApartmentData) {
		return null;
	}

	return (
		<button
			id="cadaplus-apartment-query"
			data-apartment-number={activeApartmentData.id_original}
			className={`${buttons_styles['bim_button--wide']} ${buttons_styles['bim_button--cta']} `}
			onClick={handleClick}
		>
			<span>{`Wyślij zapytanie`}</span>
			<span 
				className={styles.apartmentNumberText}
				style={{
					display: 'inline-block',
					maxWidth: isStuck ? '200px' : '0',
					paddingLeft: isStuck ? '0.5rem' : '0',
					overflow: 'hidden',
					transition: 'max-width 0.3s ease-in-out',
					whiteSpace: 'nowrap'
				}}
			>
				{` o lokal ${activeApartmentData.id_original}`}
			</span>
		</button>
	);
}

export default ApartmentQueryButton;
